<template>
    <Modal :value="value" @input="$emit('input', $event)">
        <template v-slot:title>Retirar na Escola</template>
        <div class="card-block">
            <p>Selecione a Escola que deseja fazer a Retirada</p>
            <ul class="checkout-options">
                <li
                    @click.prevent.stop="selectBranchSchool(schoolBranch.id)"
                    v-for="schoolBranch in sortedAvailableSchoolsBranches"
                >
                    <input
                        :id="`schoolbranch-${schoolBranch.id}`"
                        class="cr-radio"
                        type="radio"
                        :checked="actualBranchSchoolId && actualBranchSchoolId == schoolBranch.id"
                    />
                    <label :for="`schoolbranch-${schoolBranch.id}`">
                        <div class="checkout-option-content">
                            <div class="mx-0">
                                <p class="my-0">{{ schoolBranch.school }}</p>
                                <p class="text-small">
                                    {{ schoolBranch.address }}, {{ schoolBranch.number }} -
                                    {{ schoolBranch.city }} / {{ schoolBranch.state }} - CEP:
                                    {{ schoolBranch.postcode }}
                                </p>
                            </div>
                        </div>
                    </label>
                </li>
            </ul>
        </div>
    </Modal>
</template>

<script>
    import Modal from './container/Modal.vue';
    import { setCookie } from '../../script/common';
    export default {
        name: 'SelectSchoolBranchModal',

        components: { Modal },
        props: {
            value: {
                default: false,
            },
            actualBranchSchoolId: {
                default: null,
            },
            availableSchoolsBranches: {
                type: Object,
                default: {},
            },
        },

        computed: {
            sortedAvailableSchoolsBranches() {
                if (!this.availableSchoolsBranches) {
                    return [];
                }

                return Object.values(this.availableSchoolsBranches).sort((a, b) => {
                    return a.sort - b.sort;
                });
            },
        },

        methods: {
            selectBranchSchool(schoolBranchId) {
                let d = new Date();
                d.setTime(d.getTime() + 7 * 24 * 60 * 60 * 1000); // 7 Dias
                setCookie('branch_school_id', schoolBranchId, d.toUTCString());

                this.$emit('selected-school-branch', schoolBranchId);
            },
        },
    };
</script>
